<div id="home">
  <div class="section home" id="section">
    <div class="big-button" (click)="goToUrl(new_reservation_url)">
      <div class="img-button">
        <img
          src="../../../../assets/img/calendar.svg"
          [alt]="'new ' + flux + ' reservation'"
        />
      </div>
      <button class="my-button filled">
        {{ "home.new_reservations" | translate }}
      </button>
    </div>

    @if (userService.isEmployee()) {
      <div
        class="big-button"
        (click)="goToUrl(list_reservation_url)"
      >
        <div class="img-button">
          <img
            src="../../../../assets/img/ticket.svg"
            [alt]="'my ' + flux + ' reservations'"
          />
        </div>
        <button class="my-button filled">
          {{ "home.my_reservations" | translate }}
        </button>
      </div>
    }
  </div>
</div>
